import React from 'react';

const HeaderSection = () => {
  return (
    <div className="p-8 min-w-[320px] max-w-[600px] mx-auto">
      <h2 className="text-[#f5c956] text-sm font-bold uppercase tracking-wide">
        ABOUT NKENNEAi
      </h2>
      
      <div className="mt-4 space-y-4">
        <h1 className="text-[#fdfdfd] text-3xl md:text-4xl font-extrabold leading-tight">
          Connecting Africa One Language At A Time
        </h1>
        
        <p className="text-white text-base leading-relaxed">
          Language should be a bridge, not a barrier. At NKENNEAi, we're strengthening that bridge every day—creating a future where every African language is celebrated, supported, and heard.
        </p>
      </div>

      <button 
        className="mt-6 bg-[#f9f9f9] text-black px-8 py-2 rounded-lg text-base 
                   hover:bg-white transition-colors duration-300 
                   focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50"
      >
        Learn More
      </button>
    </div>
  );
};

export default HeaderSection;

